import root from './_root.js';

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

export default coreJsData;



// WEBPACK FOOTER //
// webpack://ClassicEditor/Users/pomek/Projects/ckeditor/ckeditor5/node_modules/lodash-es/_coreJsData.js